import { _,Marionette } from '../../../../vendor'
import { Biscuit } from '../../../utils'
import InboomaBaseCollectionView from '../../InboomaBaseCollectionView'

import DefaultReservationForm from './DefaultReservationForm'
import BikesReservationForm from './BikesReservationForm'

export default InboomaBaseCollectionView.extend({

    childView (model) {
        // @todo Clients with multiple packages shall first select a resourcetype

        if (Biscuit.get('client.isVehicleOwner') === 'true' || Biscuit.get('client.hasParkingLots') === 'true') {
            return BikesReservationForm;
        } else {
            return DefaultReservationForm;
        }
    },
    
    template: _.noop,
    _count: 0,

    preventFromSubmit : false,

    childViewOptions (model) {

        this._count++;

        let toggleOpen = false;

        if (this.options.toggleReservation !== '' && this.options.toggleReservation !== null) {
            if (model.get('id') == this.options.toggleReservation) {
                toggleOpen = true;
            }
        } else if (this._count === 1) {
            toggleOpen = true;
        }

        return {
            toggleOpen,
            indexNumber : this._count,
            preventFromSubmit : this.getOption('preventFromSubmit')
        }
    },

    _checkForEmptyCollection : _.noop, // Don't show "no models in collection" announcement

    initialize () {
        Marionette.CollectionView.prototype.initialize.apply(this);
        this.render();
    },

    /**
     * Calls reservation.save() on all children views
     */
    bulkSaveReservations () {

        _.each(this._children._views, (view) => {
            delete view.options.preventFromSubmit;
            view.saveReservation(false);
        });
  }

})
